import { ValidationRules, OptionType } from '../types';

/**
 * Valida un valor único contra un set de reglas.
 * Retorna string con error o null si es válido.
 */
export const validateValue = (
    value: string | number | null | undefined, 
    type: OptionType, 
    rules?: ValidationRules
): string | null => {
    
    // 1. Si no hay reglas, es válido (salvo que sea 'required', que se valida a nivel pregunta)
    if (!rules) return null;
    
    // Si está vacío y no estamos validando requerimiento aquí, pasamos (eso lo maneja is_required en el padre)
    if (value === null || value === undefined || value === '') return null;

    // Convertimos a string para regex/longitud
    const strVal = String(value);
    const numVal = Number(value);

    // 2. Validación de Regex
    if (rules.regex) {
        const pattern = new RegExp(rules.regex);
        if (!pattern.test(strVal)) {
            return rules.custom_error || "El formato no es válido.";
        }
    }

    // 3. Validaciones Numéricas (Min/Max Valor)
    if (type === 'number') {
        if (!isNaN(numVal)) {
            if (rules.min !== undefined && numVal < rules.min) {
                return rules.custom_error || `El valor debe ser mayor o igual a ${rules.min}.`;
            }
            if (rules.max !== undefined && numVal > rules.max) {
                return rules.custom_error || `El valor debe ser menor o igual a ${rules.max}.`;
            }
        }
    }

    // 4. Validaciones de Texto (Min/Max Longitud)
    // Solo aplicamos si el tipo NO es estrictamente numérico, o si queremos validar longitud de caracteres
    if (type === 'text' || type === 'textarea') {
        if (rules.min !== undefined && strVal.length < rules.min) {
            return rules.custom_error || `Debe tener al menos ${rules.min} caracteres.`;
        }
        if (rules.max !== undefined && strVal.length > rules.max) {
            return rules.custom_error || `No puede superar los ${rules.max} caracteres.`;
        }
    }

    return null;
};

/**
 * Valida un Archivo antes de subirlo (Peso y Extensión)
 */
export const validateFileObject = (file: File, rules?: ValidationRules): string | null => {
    if (!rules) return null;

    // 1. Peso (MB)
    if (rules.max_file_size) {
        const sizeInMB = file.size / 1024 / 1024;
        if (sizeInMB > rules.max_file_size) {
            return rules.custom_error || `El archivo pesa ${sizeInMB.toFixed(2)}MB. Máximo permitido: ${rules.max_file_size}MB.`;
        }
    }

    // 2. Extensiones
    if (rules.file_extensions && rules.file_extensions.length > 0) {
        const fileName = file.name.toLowerCase();
        // Chequeamos si alguna extensión coincide (ej: .pdf, .jpg)
        const hasValidExt = rules.file_extensions.some(ext => 
            fileName.endsWith(ext.toLowerCase().replace('*', '')) // Maneja ".jpg" o "*.jpg"
        );

        if (!hasValidExt) {
            return rules.custom_error || `Formato no permitido. Use: ${rules.file_extensions.join(', ')}`;
        }
    }

    return null;
};